import { render, staticRenderFns } from "./WordExplanation.vue?vue&type=template&id=4f27eb52&scoped=true&"
import script from "./WordExplanation.vue?vue&type=script&lang=js&"
export * from "./WordExplanation.vue?vue&type=script&lang=js&"
import style0 from "./WordExplanation.vue?vue&type=style&index=0&id=4f27eb52&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f27eb52",
  null
  
)

export default component.exports